import { memo } from "react";

const NotificationsIcon = () => (
  <svg
    width={33}
    height={32}
    id="notificationIcon"
    viewBox="0 0 33 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x={1}
      y={0.5}
      width={31}
      height={31}
      rx={15.5}
      stroke="#919EAB"
      strokeOpacity={0.24}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.5085 8.80138C13.5599 7.67998 14.9947 7.04175 16.5 7.04175C18.0054 7.04175 19.4402 7.67998 20.4915 8.80138C21.5416 9.92142 22.125 11.4324 22.125 13.0001C22.125 16.0255 22.7322 17.9258 23.3065 19.0489C23.5943 19.6116 23.8765 19.9846 24.0767 20.21C24.177 20.323 24.2572 20.3994 24.3078 20.4444C24.3332 20.4669 24.3512 20.4816 24.3606 20.4891L24.3679 20.4948C24.5855 20.6532 24.6774 20.9334 24.5954 21.1902C24.5127 21.4492 24.272 21.6251 24 21.6251H9.00004C8.72811 21.6251 8.48738 21.4492 8.40466 21.1902C8.32265 20.9334 8.41463 20.6532 8.63219 20.4948L8.63946 20.4891C8.64891 20.4816 8.6669 20.4669 8.69224 20.4444C8.7429 20.3994 8.82308 20.323 8.92337 20.21C9.12362 19.9846 9.40584 19.6116 9.69358 19.0489C10.2678 17.9258 10.875 16.0255 10.875 13.0001C10.875 11.4324 11.4585 9.92142 12.5085 8.80138Z"
      fill="#637381"
    />
    <path
      d="M18.2554 22.9595C18.554 23.1327 18.6556 23.5151 18.4824 23.8137C18.281 24.161 17.9918 24.4492 17.6439 24.6496C17.296 24.85 16.9016 24.9555 16.5001 24.9555C16.0986 24.9555 15.7042 24.85 15.3563 24.6496C15.0084 24.4492 14.7193 24.161 14.5178 23.8137C14.3446 23.5151 14.4463 23.1327 14.7448 22.9595H18.2554Z"
      fill="#637381"
    />
  </svg>
);
export default memo(NotificationsIcon);
